export const TRAINING_NAV = [
    {href: "#who-we-are", label: "Who we are"},
    {href: "#solutions", label: "Solutions"},
    {href: "#sectors", label: "Sectors"},
    {href: "#how-we-work", label: "How we work"},
    {href: "#gallery", label: "In the room"},
    {href: "#engage", label: "Engage"},
];

export const TRAINING_GALLERY = [
    {src: "/public/training/session-huddle.jpg", alt: "Participants working through an exercise together"},
    {src: "/public/training/session-speaking.jpg", alt: "Facilitator presenting to the room"},
    {src: "/public/training/workshop.jpg", alt: "Hands-on group activity in the training room"},
    {src: "/public/training/session-group.jpg", alt: "Training cohort in the classroom"},
    {src: "/public/training/session-listen.jpg", alt: "Facilitator during a live session"},
    {src: "/public/training/session-room.jpg", alt: "A full training room following the session"},
    {src: "/public/training/session-certificates.jpg", alt: "Participants receiving certificates after training"},
    {src: "/public/training/cohort.jpg", alt: "Training participants outdoors after a session"},
];

export const TRAINING_PROMISES = [
    {
        title: "Relevant to the job",
        text: "Learning objectives connected to real workplace responsibilities.",
    },
    {
        title: "Practical by design",
        text: "Discussions, case studies, exercises and action planning — not lectures alone.",
    },
    {
        title: "Adapted to context",
        text: "Content shaped around the client’s sector, team, tools and priorities.",
    },
    {
        title: "Focused on application",
        text: "Participants leave with practical outputs and next steps.",
    },
    {
        title: "Accountable delivery",
        text: "Clear plans, participant feedback and agreed completion reporting.",
    },
];

export const TRAINING_SOLUTIONS = [
    {
        number: "01",
        title: "Technical Workforce Readiness",
        audience: "Technicians, field teams, installers, service staff and technical supervisors.",
        items: [
            "Workplace communication and customer service for technicians",
            "Teamwork, problem-solving, reporting and professional conduct",
            "Solar PV operation and maintenance, safety and quality service",
            "Customer handover, after-sales service and maintenance planning",
        ],
    },
    {
        number: "02",
        title: "Commercial Skills for Energy Businesses",
        audience: "Sales, marketing, customer support, business development teams and entrepreneurs.",
        items: [
            "Sales and business development for renewable energy",
            "Customer segmentation, value propositions and lead generation",
            "Customer relationship management and service excellence",
            "Negotiation, proposal writing and digital marketing",
            "Business planning and market development",
        ],
    },
    {
        number: "03",
        title: "Leadership & Professional Development",
        audience: "Early- and mid-career professionals, team leaders and emerging managers.",
        items: [
            "Leadership, communication and influencing skills",
            "Supervisory skills, delegation and constructive feedback",
            "Negotiation, conflict management and problem-solving",
            "Career development, confidence and professional visibility",
            "Women’s leadership, mentoring and inclusive workplaces",
        ],
    },
    {
        number: "04",
        title: "Project, Programme & Organisational Performance",
        audience: "Project teams, programme staff, managers, NGOs and implementing partners.",
        items: [
            "Project design, planning and scheduling",
            "Budgeting, risk management and stakeholder engagement",
            "Monitoring, evaluation, accountability and learning",
            "Results frameworks, reporting and evidence-informed decisions",
            "Training of trainers, facilitation skills and organisational reviews",
        ],
    },
];

export const TRAINING_SECTORS = [
    {
        title: "Renewable energy & energy access",
        text: "Workforce readiness, customer service, sales, installation and maintenance practices, quality and service delivery.",
    },
    {
        title: "Productive use of renewable energy",
        text: "Solar irrigation, cooling and drying, agro-processing applications, demand assessment and service-based business models.",
    },
    {
        title: "Electric mobility",
        text: "E-mobility ecosystem awareness, charging-service models, customer engagement, workforce development and business opportunities.",
    },
    {
        title: "Development programmes & partners",
        text: "Project delivery, gender-responsive programming, stakeholder engagement, monitoring and evaluation, reporting and organisational capacity.",
    },
];

export const TRAINING_STEPS = [
    {
        number: "01",
        title: "Diagnose",
        text: "Clarify the business objective, skills gap, participant profile and operating context. Where useful, review existing materials or run a short needs assessment.",
    },
    {
        number: "02",
        title: "Design",
        text: "Agree learning outcomes, agenda, exercises, materials, facilitator requirements, delivery format and assessment approach.",
    },
    {
        number: "03",
        title: "Deliver",
        text: "Facilitate interactive sessions with relevant examples, case work, practice, discussion and participant action planning.",
    },
    {
        number: "04",
        title: "Assess",
        text: "Use proportionate checks such as pre/post questions, practical exercises, participant feedback or demonstrations of learning.",
    },
    {
        number: "05",
        title: "Support application",
        text: "Where agreed, provide action plans, manager follow-up prompts, coaching or a post-training review.",
    },
    {
        number: "06",
        title: "Report",
        text: "Provide agreed documentation: attendance, evaluation summary, learning results and recommendations for next steps.",
    },
];

export const TRAINING_START_STEPS = [
    "Share your organisational objectives and target participants.",
    "Identify the skills or performance gap you want to address.",
    "Agree learning outcomes, format, timing and budget.",
    "Receive a tailored training outline and quotation.",
];
